import { Typography } from "@mui/material";
import { Toggle } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { useStyles } from "../../AchievementForm.styles";

export const StatusSection = () => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <>
      <Typography fontWeight={500} mt={8}>
        {message({ id: "achievementStatus" })}
      </Typography>
      <Typography className={classes.descriptionNote}>
        {message({ id: "achievementStartWhenActive" })}
      </Typography>
      <Toggle
        data-test-id="active-achievement"
        label={message({ id: "active" })}
        name="active"
        className={classes.activeToggle}
      />
    </>
  );
};
